module.exports = __webpack_public_path__ + "static/media/wa-background-dark.c8f3f7c0.jpg";